// extracted by mini-css-extract-plugin
module.exports = {"verticalMenu":"_81o_r_D2OQ1P3kc-zN25J","menuWrapper":"ZLkastvlOaThQjz4ztIBK","title":"_39F57XnkUNzbBC8kdSDKUG","content":"_1haegMJsRymFreW0839y8i"};